module.exports = __webpack_public_path__ + "static/media/natalia.3e91469b.jpg";